<template>
  <iframe-page
    :src="src"
    title="Conservatory"
    :back-link="backLink"
    @iframe-message="handleMessage"
  >
    <div
      v-if="level"
      class="custom-content"
    >
      <router-link
        v-if="showPano"
        class="button"
        :to="{name: 'conservatory-view', params: { exhibitslug: level } }"
      >
        All Media
      </router-link>
    </div>
    <modal-popup
      ref="modal"
      button-text="Close"
      @close="modalClose"
    >
      <template v-slot:header>
        <h1>{{ hotspot.title }}</h1>
      </template>
      <template v-slot:body>
        <img
          v-if="hotspot.image && !hotspot.video"
          :src="hotspot.image.url"
        >
        <exhibit-videos
          v-if="videos"
          :videos="videos"
          @plyrs-loaded="playersLoaded"
        />
        <!-- eslint-disable vue/no-v-html -->
        <ContentText
          v-if="hotspot.content"
          v-html="hotspot.content"
        />
        <!-- eslint-enable -->
      </template>
      <template v-slot:footer>
&nbsp;
      </template>
    </modal-popup>
  </iframe-page>
</template>

<script>
import IframePage from './IframePage'
import ExhibitData from "../mixins/ExhibitData.vue"
import ExhibitVideos from "../components/ExhibitVideos.vue"

export default {
    name: 'ConservatoryPano',
    components: {
        IframePage,
        ExhibitVideos
    },
    mixins: [
      ExhibitData
    ],
    props: {
      showPano: {
        type: Boolean,
        default: false
      },
      backLink: {
        type: [String, Object, Boolean],
        default: false
      }
    },
    data() {
        return {
            defSrc: process.env.BASE_URL + 'frames/conservatory-360/',
            level: '',
            showPopup: false,
            lastHotspot: false,
            players: []
        }
    },
    computed: {
      src() {
        return this.showPano ? process.env.BASE_URL + 'frames/conservatory-360/pano.html' : this.defSrc
      },
      exhibit() {
        if (this.exhibitsLoaded) {
          return this.$store.getters.allExhibits[this.level]
        }
        return false
      },
      hotspot() {
        var hs = { content: 'No hotspot found for ' + this.lastHotspot}
        if (this.exhibit && this.exhibit.data.hotspots) {
          const ths = this.exhibit.data.hotspots.find(i => this.lastHotspot === i.click_trigger)
          if (ths) {
            hs = ths
          }
        }
        return hs
      },
      videos() {
        if (this.hotspot.video) {
          return [{
            file: this.hotspot.video,
            cover: {
              url: this.hotspot.image.url
            }
          }]
        }
        return false
      },
      linklevel() {
          if ( this.level == 'bottom' ) {
              return 'ground-floor'
          }
          if ( this.level == 'middle' ) {
              return 'tree-line'
          }
          if ( this.level == 'top' ) {
              return 'top-of-the-dome'
          }
          return this.level
      }
    },
    methods: {
        handleMessage(event) {
            if (event.data.event == 'view-level') {
                this.level = event.data.data
                this.$gtm.trackEvent({
                  category: 'Pano Level',
                  action: 'View ' + event.data.data
                })
            }
            if (event.data.event == 'up' || event.data.event == 'down') {
              this.$gtm.trackEvent({
                category: 'Pano Navigation',
                action: event.data.event
              })
            }
            if (event.data.event == 'hotspot-click') {
              this.lastHotspot = event.data.data
              this.$gtm.trackEvent({
                category: 'Hotspots - ' + this.level,
                action: 'Click',
                label: this.hotspot.title
              })
              this.$refs.modal.open()
            }
        },
        popDown() {
          this.$refs.modal.close()
        },
        modalClose() {
          this.players.forEach((plyr) => plyr.player.pause())
        },
        playersLoaded(plyrs) {
          this.players = plyrs
          plyrs.forEach((plyr) => {
            console.log(plyr)
            plyr.player.on('play', () => {
              this.$gtm.trackEvent({
                category: 'Hotspots - ' + this.level,
                action: 'Play Video',
                label: this.hotspot.title
              })
            })
          })
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .custom-content {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}
</style>
